// Short, subdued two-tone chime for positive feedback (e.g. dictation word done).
// Uses Web Audio API — separate from TTS and metronome.

let sharedCtx: AudioContext | null = null;

function getContext(): AudioContext | null {
  if (sharedCtx) return sharedCtx;
  if (typeof window === 'undefined') return null;
  try {
    const Ctx =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;
    if (!Ctx) return null;
    sharedCtx = new Ctx();
  } catch {
    sharedCtx = null;
  }
  return sharedCtx;
}

/** Call from a user gesture so later chimes are allowed (autoplay policy). */
export function primeSuccessChime(): void {
  const ctx = getContext();
  if (!ctx) return;
  void ctx.resume().catch(() => {});
}

function playTone(
  ctx: AudioContext,
  frequency: number,
  startAt: number,
  peakGain: number,
  durationSec: number,
): void {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.value = frequency;
  gain.gain.setValueAtTime(0.0001, startAt);
  gain.gain.exponentialRampToValueAtTime(peakGain, startAt + 0.012);
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + durationSec);
  osc.connect(gain).connect(ctx.destination);
  osc.start(startAt);
  osc.stop(startAt + durationSec + 0.02);
}

/** Soft game-like success: rising fifth (C5 → G5), ~180 ms total. */
export function playSuccessChime(): void {
  const ctx = getContext();
  if (!ctx) return;
  void ctx.resume().catch(() => {});
  const t0 = ctx.currentTime;
  playTone(ctx, 523.25, t0, 0.11, 0.1);
  playTone(ctx, 783.99, t0 + 0.09, 0.09, 0.12);
}
